import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function buildSheetData(columnDefs, records) {
    const defs = columnDefs.filter((col) => col.headerName !== 'ROW_ACTIONS');
    const headers = defs.map((col) => col.headerName);
    const rows = records.map((record) =>
        defs.map((col) => {
            const value = record[col.fieldName];
            return value === null || value === undefined || value === 'undefined' || value === 'null' ? '' : value;
        }),
    );
    return [headers, ...rows];
}

export function exportAsExcel(columns, records, filename = 'export') {
    const isColumnDefs = columns.length > 0
        && typeof columns[0] === 'object'
        && columns[0].headerName;

    let sheetData;
    if (isColumnDefs) {
        sheetData = buildSheetData(columns, records);
    } else if (records.length && typeof records[0] === 'object' && !Array.isArray(records[0])) {
        // Legacy: header string[] + object rows keyed by fieldName
        const headers = columns;
        const keys = Object.keys(records[0]);
        sheetData = [
            headers,
            ...records.map((record) => headers.map((header, index) => {
                const value = Object.prototype.hasOwnProperty.call(record, header)
                    ? record[header]
                    : record[keys[index]];
                return value === null || value === undefined || value === 'undefined' || value === 'null'
                    ? ''
                    : value;
            })),
        ];
    } else {
        sheetData = [columns, ...records];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`,
    );
}
